import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { BenefitSummaryList } from "src/app/models/benefit-summary";

import { BenefitService } from "src/app/services/benefit.service";

@Component({
    selector: 'mwp-member-benefits',
    templateUrl: './member-benefits.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MemberBenefitsComponent implements OnInit {
    public currentBenefits: BenefitSummaryList;
    public enrollmentRequests: BenefitSummaryList;
    public displayBenefitRequests: boolean;

    constructor(
        private benefitService: BenefitService,
    ) {
    }

    ngOnInit(): void {
        this.benefitService.getBenefits().subscribe((response: BenefitSummaryList) => {
            this.currentBenefits = response;
        });
        this.benefitService.getEnrollmentRequests().subscribe((response: BenefitSummaryList) => {
            this.enrollmentRequests = response;
            this.displayBenefitRequests = this.enrollmentRequests.summaryBenefitCards ? this.enrollmentRequests.summaryBenefitCards.length > 0 : false;
        });
    }
}